const NOMES_TOTAL: { [k: string]: string } = { soma: 'soma', media: 'média', contagem: 'contagem', distintos: 'distintos', min: 'mínimo', max: 'máximo' };

export function resumirProposta(modelo: any, fonte: any): { rotulo: string; valor: string }[] {
  if (!modelo) {
    return [];
  }
  const colunasFonte: any[] = fonte?.colunas || [];
  const rotulo = (nome: string) => colunasFonte.find((c) => c.nome === nome)?.rotulo || nome;
  const linhas: { rotulo: string; valor: string }[] = [];
  linhas.push({ rotulo: 'Fonte', valor: fonte ? `${fonte.chave} (nova)` : `${modelo.fonte} (já existe)` });
  if (fonte?.descricao) {
    linhas.push({ rotulo: 'Grão', valor: fonte.descricao });
  }
  const filtros = (modelo.filtros || []).map((f: any) => f.rotulo || (f.parametro ? f.parametro : rotulo(f.coluna)));
  linhas.push({ rotulo: 'Filtros', valor: filtros.length ? 'Empresas, ' + filtros.join(', ') : 'Empresas' });
  if (modelo.agrupamentos?.length) {
    linhas.push({ rotulo: 'Agrupamento', valor: modelo.agrupamentos.map((a: any) => a.rotulo || rotulo(a.coluna)).join(' › ') });
  }
  linhas.push({ rotulo: 'Colunas', valor: (modelo.colunas || []).map((c: any) => c.rotulo || rotulo(c.coluna)).join(', ') });
  const totais = (modelo.colunas || []).filter((c: any) => c.total);
  if (totais.length) {
    linhas.push({ rotulo: 'Totais', valor: totais.map((c: any) => `${NOMES_TOTAL[c.total] || c.total} de ${c.rotulo || rotulo(c.coluna)}`).join(', ') });
  }
  if (modelo.indicadores?.length) {
    linhas.push({ rotulo: 'Indicadores', valor: modelo.indicadores.map((i: any) => i.rotulo).join(', ') });
  }
  if (modelo.graficos?.length) {
    linhas.push({ rotulo: 'Gráficos', valor: modelo.graficos.map((g: any) => g.titulo || g.id).join(', ') });
  }
  return linhas;
}

export function rodapeUso(r: any): string {
  const partes: string[] = [];
  if (r?.tentativas > 1) {
    partes.push(`${r.tentativas} tentativas até passar na conferência`);
  }
  if (r?.uso) {
    const novos = (r.uso.entrada || 0) + (r.uso.cacheEscrito || 0) + (r.uso.saida || 0);
    partes.push(`${novos.toLocaleString('pt-BR')} tokens`);
    if (r.uso.cacheLido) {
      partes.push(`+ ${r.uso.cacheLido.toLocaleString('pt-BR')} do cache (custam 10%)`);
    }
  }
  return partes.join(' · ');
}
